import { render, staticRenderFns } from "./Stopped.vue?vue&type=template&id=488e185c&"
import script from "./Stopped.vue?vue&type=script&lang=js&"
export * from "./Stopped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports